import { CashbackBonusType } from '../../leagues';

export function parseCashback(bonus?: CashbackBonusType) {
  if (!bonus) {
    return {
      has: false,
      min: 0,
      max: 0,
    };
  }

  const [, min, max] = bonus.split('-');

  return {
    has: true,
    min: Number(min) / 100,
    max: Number(max) / 100,
  };
}
